import React from "react";

import * as S from "./styles";

export const Slide12: React.FC = () => {
  return (
    <S.Container>
      <S.Content>
        <S.Photo className="photo" />
      </S.Content>
      <S.Content className="right">
        <S.Photo2></S.Photo2>
      </S.Content>
      <S.Credit className="web">
        Na foto à esquerda, parka, R$ 2.248, e calça, R$ 998, ambas Vitor
        Zerbinato. À direita, chemise, Irrita, R$ 985.
      </S.Credit>
      <S.Credit className="mobile">
        Parka, 2.248, e calça, R$ 998, ambas Vitor Zerbinato.
      </S.Credit>
    </S.Container>
  );
};
